import { Card, Checkbox, Col, List, Row, Tabs } from 'antd';
import GetLabel from 'DisplayFramework/components/GetLabel';
import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { toCurrency } from 'utils/utils';
import {
  AssetCatalogComponentResponse,
  AssetCatalogResponse,
  getAssetCatalogByKeyword,
  ParAssetCatalogOptionResponse,
  ParAssetCatalogServiceResponse,
} from '../../services/assetconfig';
import { CATALOG_IMG_URL } from '../../utils/config';
import { Carousel } from 'antd';
import DF from 'DisplayFramework';

const { TabPane } = Tabs;
type AssetCatalogSingleItemDetailsProps = {
  item: AssetCatalogResponse;
  cataloglabel?: string;
  onCancel?: () => void;
  currcode?: string;
  onSelect?: (
    item: AssetCatalogResponse,
    selectedServices: ParAssetCatalogServiceResponse[],
    selectedOption: ParAssetCatalogOptionResponse[]
  ) => void;
  isModal?: Boolean;
};

const AssetCatalogSingleItemDetails = (
  props: AssetCatalogSingleItemDetailsProps
) => {
  const { onCancel, cataloglabel, currcode, onSelect, item, isModal } = props;

  const [selectedComponent, setselectedComponent] = useState<
    AssetCatalogComponentResponse[]
  >([]);

  const [selectedServices, setSelectedServices] = useState<
    ParAssetCatalogServiceResponse[]
  >([]);

  const [selectedOption, setselectedOption] = useState<
    ParAssetCatalogOptionResponse[]
  >([]);
  const [selectedOptcode, setselectedOptcode] = useState<any>();
  const [selectedOptvalue, setselectedOptvalue] = useState<any>();

  const [activeKey, setActiveKey] = useState('1');

  const { data: assetsCatalog } = useQuery(
    ['getAssetCatalogByKeyword', { cataloglabel }],
    () =>
      getAssetCatalogByKeyword({
        keyword: cataloglabel,
        filters: '',
        mcid: '',
        mgid: '',
        networkcode: '',
        tpidbroker: '',
        currcode: currcode,
      } as any).then((res) => res.list[0] || []),
    {
      enabled: Boolean(cataloglabel),
      staleTime: 30 * 1000,
    }
  );
  let items = props.item || assetsCatalog;

  const imageSrc = CATALOG_IMG_URL + item?.assetpictureurl;
  const imageSrc2 = CATALOG_IMG_URL + item?.assetpictureurl2;
  const imageSrc3 = CATALOG_IMG_URL + item?.assetpictureurl3;
  const imageSrc4 = CATALOG_IMG_URL + item?.assetpictureurl4;
  const imageSrc5 = CATALOG_IMG_URL + item?.assetpictureurl5;
  const imageSrc6 = CATALOG_IMG_URL + item?.assetpictureurl6;

  let imagSrcOp =
    selectedOptcode === 'COLOR' &&
    selectedOptvalue != null &&
    CATALOG_IMG_URL +
    item?.assetCatalogOptions.find((op) => op.optvalue === selectedOptvalue)
      ?.optpictureurl;

  let imageSrcOp2 =
    CATALOG_IMG_URL +
    item?.assetCatalogOptions?.find(
      (op) => op.optpictureurl2 !== null && op.optvalue === selectedOptvalue
    )?.optpictureurl2;
  const imageSrcOp3 =
    CATALOG_IMG_URL +
    item?.assetCatalogOptions?.find((op) => op.optvalue === selectedOptvalue)
      ?.optpictureurl3;
  const imageSrcOp4 =
    CATALOG_IMG_URL +
    item?.assetCatalogOptions?.find((op) => op.optvalue === selectedOptvalue)
      ?.optpictureurl4;
  const imageSrcOp5 =
    CATALOG_IMG_URL +
    item?.assetCatalogOptions?.find((op) => op.optvalue === selectedOptvalue)
      ?.optpictureurl5;
  const imageSrcOp6 =
    CATALOG_IMG_URL +
    item?.assetCatalogOptions?.find((op) => op.optvalue === selectedOptvalue)
      ?.optpictureurl6;

  const [assetnetamount, setAssetnetamount] = useState(item.assetnetamount);
  const [assettaxamount, setAssettaxamount] = useState(item.assettaxamount);
  const [assetgrossamount, setAssetgrossamount] = useState(
    item.assetgrossamount
  );

  const dotStyle = {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    backgroundColor: '#000000',
    margin: '0 8px',
  };

  useEffect(() => { }, [
    selectedServices,
    selectedOption,
    selectedComponent,
    selectedOptcode,
    selectedOptvalue,
  ]);
  return item ? (
    <DF.Provider pagcode="assetcatalogssingleitem">
        <Card>
      <Row justify="center" style={{ backgroundColor: 'white'}} gutter={18}>
        <Col span={10}>
          <Card>
          
          {!isModal ? (
            <img alt="example" style={{ width: '300px' }} src={imageSrc} />
          ) : selectedOptcode === 'COLOR' && selectedOptvalue != null ? (
            <Carousel
              autoplay
              autoplaySpeed={2000}
              style={{ outline: 'black', color: '#fff' }}
            >
              <img alt="example" style={{ width: '300px' }} src={imagSrcOp} />
              {item?.assetCatalogOptions?.map(
                (option) =>
                  option.optpictureurl2 !== undefined &&
                  option.optpictureurl2 !== '' &&
                  option.optpictureurl2 !== null && (
                    <img
                      key={option.optid}
                      alt="example"
                      style={{ width: '300px' }}
                      src={imageSrcOp2}
                    />
                  )
              )}
              {item?.assetCatalogOptions?.map(
                (option) =>
                  option.optpictureurl3 !== null &&
                  option.optpictureurl3 !== '' &&
                  option.optpictureurl3 !== undefined && (
                    <img
                      key={option.optid}
                      alt="example"
                      style={{ width: '300px' }}
                      src={imageSrcOp3}
                    />
                  )
              )}
              {item.assetCatalogOptions?.map(
                (option) =>
                  option.optpictureurl4 !== '' &&
                  option.optpictureurl4 !== null &&
                  option.optpictureurl4 !== undefined && (
                    <img
                      key={option.optid}
                      alt="example"
                      style={{ width: '300px' }}
                      src={imageSrcOp4}
                    />
                  )
              )}
              {item.assetCatalogOptions?.map(
                (option) =>
                  option.optpictureurl5 !== null &&
                  option.optpictureurl5 !== '' &&
                  option.optpictureurl5 !== undefined && (
                    <img
                      key={option.optid}
                      alt="example"
                      style={{ width: '300px' }}
                      src={imageSrcOp5}
                    />
                  )
              )}
              {item.assetCatalogOptions?.map(
                (option) =>
                  option.optpictureurl6 !== null &&
                  option.optpictureurl6 !== '' &&
                  option.optpictureurl6 !== undefined && (
                    <img
                      key={option.optid}
                      alt="example"
                      style={{ width: '300px' }}
                      src={imageSrcOp6}
                    />
                  )
              )}
            </Carousel>
          ) : (
            selectedOptcode !== 'COLOR' && (
              <Carousel
                autoplay
                autoplaySpeed={1000}
                style={{ outline: 'black', color: '#fff' }}
                dots={{ className: 'custom-dots' }}
                className="carousel-indicators"
              >
                <img alt="example" style={{ width: '300px' }} src={imageSrc} />
                {item?.assetpictureurl2 !== '' &&
                  item?.assetpictureurl2 != null && (
                    <img
                      alt={item?.assetdescription}
                      style={{ width: '300px' }}
                      src={imageSrc2}
                    />
                  )}
                {item?.assetpictureurl3 !== '' &&
                  item?.assetpictureurl3 != null && (
                    <img
                      alt={item?.assetdescription}
                      style={{ width: '300px' }}
                      src={imageSrc3}
                    />
                  )}
                {item?.assetpictureurl4 !== '' &&
                  item?.assetpictureurl4 != null && (
                    <img
                      alt={item?.assetdescription}
                      style={{ width: '300px' }}
                      src={imageSrc4}
                    />
                  )}
                {item?.assetpictureurl5 !== '' &&
                  item?.assetpictureurl5 != null && ( 
                    <img
                      alt={item?.assetdescription}
                      style={{ width: '300px' }}
                      src={imageSrc5}
                    />
                  )}
                {item?.assetpictureurl6 !== '' &&
                  item.assetpictureurl6 != null && (
                    <img
                      alt={item?.assetdescription}
                      style={{ width: '300px' }}
                      src={imageSrc6}
                    />
                  )}
              </Carousel>
            )
          )}
           <div style={{marginTop:20}}>
            {item?.assetnetamountorigine > item?.assetdiscountamount &&
              item?.assetdiscountperc !== 0 &&
              item?.assetdiscountperc != null ? (
              <>
                <Row style={{ color: 'red' }} justify="end">
                  {'-' + item.assetdiscountperc + '%'}
                </Row>
                <Row justify="center">
                  <strong style={{ fontSize: '25px',textAlign: 'center' }} className="title title-second">
                    {' '}
                    {toCurrency(
                      item.assetnetamountorigine - item?.assetdiscountamount,
                      currcode ?? localStorage.getItem('currcode') ?? ''
                    )}
                  </strong>
                </Row>
        
                <Row justify="end">
                  {toCurrency(item.assetnetamountorigine, currcode ?? localStorage.getItem('currcode') ?? '')}
                </Row>
              </>
            ) : (
                <Row justify="center">
                    <strong style={{ marginRight: '2%', fontSize: '20px', textAlign:'center' }} className="title title-second">
                        {assetnetamount
                        ? toCurrency(assetnetamount, currcode ?? localStorage.getItem('currcode') ?? '')
                        : toCurrency(item.assetnetamountorigine, currcode ?? localStorage.getItem('currcode') ?? '')}
                    </strong>
              </Row>
            )}
          </div>
        </Card>
        </Col>
     
        <Col span={14}>
          <strong style={{ fontSize: '20px' }}>
            <GetLabel label="Description : " />
          </strong>
          <br />
          {items.assetdescription}
          <br />
          <div>
            <strong>
              <GetLabel label="Constructor" />:{' '}
            </strong>
            {item?.assetconstructor}
          </div>
          <div>
            <strong>
              <GetLabel label="Variant" />:{' '}
            </strong>
            {item?.assetvariant}
          </div>
         
       
     
      {(item?.assetCatalogComponents?.length > 0 ||
        item?.assetCatalogServices?.length > 0 ||
        item?.assetCatalogOptions?.length > 0) && (
          <Tabs
            activeKey={activeKey}
            onChange={(e) => {
              setActiveKey(e);
            }}
            tabPosition="top"
          >
            <TabPane tab={<GetLabel label="Component" />} key="1" animated>
                <Card
                  className="AssetCatalogSingleItem"
                  bordered={false}
                >
                  {item?.assetCatalogComponents?.length > 0 && (
                    <List
                      size="small"
                      style={{
                        marginTop: '-30px',
                        marginBottom: 20,
                      }}
                      dataSource={item?.assetCatalogComponents ?? []}
                      renderItem={(e) => (
                        <List.Item>                        
                            <Col span={16}>
                                {`${e.compdescription}`}:
                            </Col>
                            <Col span={8}>
                            <span>
                                {` ${toCurrency(e.compnetamount, item.currcode)}`}
                                </span>
                            </Col>
                        </List.Item>
                      )}
                    />
                  )}
                </Card>
            </TabPane>

            <TabPane tab={<GetLabel label="Services" />} key="2">
              <Col span={20}>
                <Card
                  bordered={false}
                >
                  <Row>
                    {item.assetCatalogServices?.length > 0 && (
                      <List
                        dataSource={item?.assetCatalogServices ?? []}
                        renderItem={(e) => (
                          <List.Item>
                            {isModal ? (
                              <Checkbox
                                value={e.servcode}
                                onChange={(a) => {
                                  if (a.target.checked) {
                                    setSelectedServices([...selectedServices, e]);
                                    setAssetnetamount(
                                      assetnetamount + e.servfixedamount
                                    );
                                  } else {
                                    let itemserv = selectedServices.filter(
                                      (i) => i.servcode !== a.target.value
                                    );
                                    setAssetnetamount(
                                      assetnetamount - e.servfixedamount
                                    );
                                    setSelectedServices(itemserv);
                                  }
                                }}
                              >
                                <Col>
                                  {`${e.servlabel}`}:
                                  <span
                                    style={{
                                      float: 'right',
                                    }}
                                  >{` ${toCurrency(
                                    e.servfixedamount,
                                    item.currcode
                                  )}`}</span>
                                </Col>
                              </Checkbox>
                            ) : (
                              <Col>
                                {`${e.servlabel}`}:
                                <span
                                  style={{
                                    float: 'right',
                                  }}
                                >{` ${toCurrency(
                                  e.servfixedamount,
                                  item.currcode
                                )}`}</span>
                              </Col>
                            )}
                          </List.Item>
                        )}
                      />
                    )}
                  </Row>
                </Card>
              </Col>
            </TabPane>

            <TabPane tab={<GetLabel label="Options" />} key="3">
              <Row>
                <Card
                  style={{ alignContent: 'center', width: 290, padding: 0 }}
                  className="AssetCatalogSingleItem"
                  bordered={false}
                >
                  {item?.assetCatalogOptions?.length > 0 && (
                    <List
                      size="small"
                      style={{
                        width: '100%',
                        marginTop: '-30px',
                        marginBottom: 20,
                      }}
                      dataSource={item?.assetCatalogOptions ?? []}
                      renderItem={(e) => (
                        <List.Item>
                          {isModal ? (
                            <Checkbox
                              value={e.optvalue}
                              onChange={(a) => {
                                if (a.target.checked) {
                                  setselectedOption([...selectedOption, e]);

                                  setselectedOptcode(e.optcode);
                                  setselectedOptvalue(e.optvalue);
                                  setAssetnetamount(
                                    assetnetamount + e.optnetamount
                                  );
                                  setAssettaxamount(
                                    assettaxamount + e.opttaxamount
                                  );
                                  setAssetgrossamount(
                                    assetgrossamount + e.optgrossamount
                                  );
                                } else {
                                  let itemop = selectedOption.filter(
                                    (i) => i.optvalue !== a.target.value
                                  );
                                  setAssetnetamount(
                                    assetnetamount - e.optnetamount
                                  );
                                  setAssettaxamount(
                                    assettaxamount - e.opttaxamount
                                  );
                                  setAssetgrossamount(
                                    assetgrossamount - e.optgrossamount
                                  );
                                  setselectedOptcode(undefined);
                                  setselectedOption(itemop);
                                }
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                }}
                              >
                                <Col>
                                  {`${e.optcodelabel} 
                              : 
                              ${e.optvaluelabel ? e.optvaluelabel : ''} 
                              : 
                              ${toCurrency(e.optnetamount, item.currcode)}`}
                                </Col>
                              </div>
                            </Checkbox>
                          ) : (
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                              }}
                            >
                              <Col>
                                {`${e.optcodelabel} 
                              : 
                              ${e.optvaluelabel ? e.optvaluelabel : ''} 
                              : 
                              ${toCurrency(e.optnetamount, item.currcode)}`}
                              </Col>
                            </div>
                          )}
                        </List.Item>
                      )}
                    />
                  )}
                </Card>
              </Row>
            </TabPane>
          </Tabs>
        )}
        </Col>
        </Row>
        </Card>
    </DF.Provider>
  ) : null;
};

export default AssetCatalogSingleItemDetails;
